export default __webpack_public_path__ + "static/timberline-customer-service-8cbf624bcfaea17d27b41fe81c0dac42.jpg";